<template>
    <div class="carousel">
        <div class="carousel-track" :style="trackStyle">
            <div
                class="carousel-slide"
                v-for="(slide, index) in slides"
                :key="index"
                v-html="slide.content"
            />
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
    slides: {
        type: Array,
        required: true
    },
    interval: {
        type: Number,
        default: 10000 // 10 seconds
    }
})

const current = ref(0)
let autoplayTimer = null

const next = () => {
    current.value = (current.value + 1) % props.slides.length
}

const trackStyle = computed(() => ({
    transform: `translateX(-${current.value * 100}%)`
}))

onMounted(() => {
    autoplayTimer = setInterval(next, props.interval)
})

onBeforeUnmount(() => {
    clearInterval(autoplayTimer)
})
</script>

<style scoped>

.carousel {
    position: relative;
    width: 100%;
    max-width: 600px;
    overflow: hidden;
    margin: auto;
}

.carousel-track {
    display: flex;
    transition: transform 0.5s ease-in-out;
}

.carousel-slide {
    min-width: 100%;
    box-sizing: border-box;
}
</style>
